// @flow
import { ReactComponent as Download } from 'esm-web-pro/assets/images/download.svg';
import styled, { css } from 'styled-components';

const DownloadIcon = styled(Download)`
    ${(props) => css`
        height: ${props.size || props.theme.icon.size.medium}};
        width: ${props.size || props.theme.icon.size.medium};
    `}
`;

export default DownloadIcon;
